import i18n from '../../plugins/i18n';

const data = {
	tooltips: {
		client: {
			backgroundImage: {
				pt: i18n.t('CLIENT__BACKGROUND_IMAGE'),
				en: i18n.t('CLIENT__BACKGROUND_IMAGE'),
				es: i18n.t('CLIENT__BACKGROUND_IMAGE'),
			},
			documentationUrl: {
				pt: i18n.t('CLIENT__MESSAGE_DOCUMENTATION_URL'),
				en: i18n.t('CLIENT__MESSAGE_DOCUMENTATION_URL'),
				es: i18n.t('CLIENT__MESSAGE_DOCUMENTATION_URL'),
			},
			jiraUrl: {
				pt: i18n.t('CLIENT__MESSAGE_JIRA_URL'),
				en: i18n.t('CLIENT__MESSAGE_JIRA_URL'),
				es: i18n.t('CLIENT__MESSAGE_JIRA_URL'),
			},
			connectionUrl: {
				pt: i18n.t('CLIENT__MESSAGE_CONNECT_URL'),
				en: i18n.t('CLIENT__MESSAGE_CONNECT_URL'),
				es: i18n.t('CLIENT__MESSAGE_CONNECT_URL'),
			},
			connectionKinesisUrl: {
				pt: i18n.t('CLIENT__MESSAGE_CONNECT_KINESIS_URL'),
				en: i18n.t('CLIENT__MESSAGE_CONNECT_KINESIS_URL'),
				es: i18n.t('CLIENT__MESSAGE_CONNECT_KINESIS_URL'),
			},
			logoImage: {
				pt: i18n.t('CLIENT__LOGO_IMAGE'),
				en: i18n.t('CLIENT__LOGO_IMAGE'),
				es: i18n.t('CLIENT__LOGO_IMAGE'),
			},
			supportEmail: {
				pt: i18n.t('CLIENT__MESSAGE_SUPPORT_EMAIL'),
				en: i18n.t('CLIENT__MESSAGE_SUPPORT_EMAIL'),
				es: i18n.t('CLIENT__MESSAGE_SUPPORT_EMAIL'),
			},
			supportWhatsapp: {
				pt: i18n.t('CLIENT__MESSAGE_SUPPORT_WHATSAPP'),
				en: i18n.t('CLIENT__MESSAGE_SUPPORT_WHATSAPP'),
				es: i18n.t('CLIENT__MESSAGE_SUPPORT_WHATSAPP'),
			},
			themeSlogan: {
				pt: i18n.t('CLIENT__MESSAGE_THEME_SLOGAN'),
				en: i18n.t('CLIENT__MESSAGE_THEME_SLOGAN'),
				es: i18n.t('CLIENT__MESSAGE_THEME_SLOGAN'),
			},
			themeSlug: {
				pt: i18n.t('CLIENT__MESSAGE_THEME_SLUG'),
				en: i18n.t('CLIENT__MESSAGE_THEME_SLUG'),
				es: i18n.t('CLIENT__MESSAGE_THEME_SLUG'),
			},
			themeLogoImage: {
				pt: i18n.t('CLIENT__LOGO_IMAGE'),
				en: i18n.t('CLIENT__LOGO_IMAGE'),
				es: i18n.t('CLIENT__LOGO_IMAGE'),
			},
			ticketUrl: {
				pt: i18n.t('CLIENT__MESSAGE_TICKET_URL'),
				en: i18n.t('CLIENT__MESSAGE_TICKET_URL'),
				es: i18n.t('CLIENT__MESSAGE_TICKET_URL'),
			},
		},

		logSchema: {
			priority: {
				pt: i18n.t('LOG_SCHEMA__PRIORITY'),
				en: i18n.t('LOG_SCHEMA__PRIORITY'),
				es: i18n.t('LOG_SCHEMA__PRIORITY'),
			},
		},
	},
	dialog: {
		action: {
			add: {
				title: i18n.t('ACTION__TITLE_ADD'),
				message: i18n.t('ACTION__MESSAGE_ADD'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			update: {
				title: i18n.t('ACTION__TITLE_UPDATE'),
				message: i18n.t('ACTION__MESSAGE_UPDATE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			remove: {
				title: i18n.t('ACTION__TITLE_REMOVE'),
				message: i18n.t('ACTION__MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
		},
		camera: {
			add: {
				title: i18n.t('CAMERA__TITLE_ADD'),
				message: i18n.t('CAMERA__MESSAGE_ADD'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			update: {
				title: i18n.t('CAMERA__TITLE_UPDATE'),
				message: i18n.t('CAMERA__MESSAGE_UPDATE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			remove: {
				title: i18n.t('CAMERA__TITLE_REMOVE'),
				message: i18n.t('CAMERA__MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
		},
		board: {
			add: {
				title: i18n.t('BOARDS__BOARD_ADD'),
				message: i18n.t('BOARDS__BOARD_MESSAGE_ADD'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			update: {
				title: i18n.t('BOARDS__TITLE_UPDATE'),
				message: i18n.t('BOARDS__MESSAGE_UPDATE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			remove: {
				title: i18n.t('BOARDS__TITLE_REMOVE'),
				message: i18n.t('BOARDS__MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
		},
		client: {
			add: {
				title: i18n.t('CLIENT__ACCOUNT_ADD'),
				message: i18n.t('CLIENT__ACCOUNT_MESSAGE_ADD'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			update: {
				title: i18n.t('CLIENT__ACCOUNT_UPDATE'),
				message: i18n.t('CLIENT__ACCOUNT_MESSAGE_UPDATE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			remove: {
				title: i18n.t('CLIENT__ACCOUNT_REMOVE'),
				message: i18n.t('CLIENT__ACCOUNT_MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
			deleteFile: {
				title: i18n.t('COMMON__FILE_REMOVE'),
				message: i18n.t('COMMON__MESSAGE_FILE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
		},
		contract: {
			add: {
				title: i18n.t('CONTRACT__TITLE_ADD'),
				message: i18n.t('CONTRACT__MESSAGE_ADD'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			update: {
				title: i18n.t('CONTRACT__TITLE_UPDATE'),
				message: i18n.t('CONTRACT__MESSAGE_UPDATE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			remove: {
				title: i18n.t('CONTRACT__TITLE_REMOVE'),
				message: i18n.t('CONTRACT__MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
			deleteFile: {
				title: i18n.t('COMMON__FILE_REMOVE'),
				message: i18n.t('COMMON__MESSAGE_FILE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
		},
		device: {
			add: {
				title: i18n.t('DEVICE__TITLE_ADD'),
				message: i18n.t('DEVICE__MESSAGE_ADD'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			update: {
				title: i18n.t('DEVICE__TITLE_UPDATE'),
				message: i18n.t('DEVICE__MESSAGE_UPDATE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			remove: {
				title: i18n.t('DEVICE__TITLE_REMOVE'),
				message: i18n.t('DEVICE__MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
			addBulk: {
				title: i18n.t('DEVICES__TITLE_ADD_BATCH'),
				message: i18n.t('DEVICES__MESSAGE_ADD_BATCH'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			updateBulk: {
				title: i18n.t('DEVICES__TITLE_UPDATE_BATCH'),
				message: i18n.t('DEVICES__MESSAGE_UPDATE_BATCH'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			removeBulk: {
				title: i18n.t('DEVICES__TITLE_REMOVE_BATCH'),
				message: i18n.t('DEVICES__MESSAGE_REMOVE_BATCH'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
			addMaintenance: {
				title: i18n.t('DEVICE__MAINTENANCE_TITLE_ADD'),
				message: i18n.t('DEVICE__MAINTENANCE_MESSAGE_ADD'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			updateMaintenance: {
				title: i18n.t('DEVICE__MAINTENANCE_TITLE_UPDATE'),
				message: i18n.t('DEVICE__MAINTENANCE_MESSAGE_UPDATE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			removeMaintenance: {
				title: i18n.t('DEVICE__MAINTENANCE_TITLE_REMOVE'),
				message: i18n.t('DEVICE__MAINTENANCE_MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			removeMaintenanceFile: {
				title: i18n.t('DEVICE__MAINTENANCE_TITLE_REMOVE'),
				message: i18n.t('DEVICE__MAINTENANCE_MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			removeDeviceFile: {
				title: i18n.t('DEVICE__DOCUMENT_TITLE_REMOVE'),
				message: i18n.t('DEVICE__DOCUMENT__MESSAGE_FILE_REMOVED'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
		},
		engine: {
			add: {
				title: i18n.t('ENGINE__TITLE_ADD'),
				message: i18n.t('ENGINE__MESSAGE_ADD'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			update: {
				title: i18n.t('ENGINE__TITLE_UPDATE'),
				message: i18n.t('ENGINE__MESSAGE_UPDATE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			remove: {
				title: i18n.t('ENGINE__TITLE_REMOVE'),
				message: i18n.t('ENGINE__MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
		},
		employee: {
			add: {
				title: i18n.t('EMPLOYEE__TITLE_ADD'),
				message: i18n.t('EMPLOYEE__MESSAGE_ADD'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			update: {
				title: i18n.t('EMPLOYEE__TITLE_UPDATE'),
				message: i18n.t('EMPLOYEE__MESSAGE_UPDATE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			remove: {
				title: i18n.t('EMPLOYEE__TITLE_REMOVE'),
				message: i18n.t('EMPLOYEE__MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
			deleteFile: {
				title: i18n.t('COMMON__FILE_REMOVE'),
				message: i18n.t('COMMON__MESSAGE_FILE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
			addBulk: {
				title: i18n.t('EMPLOYEES__TITLE_ADD_BATCH'),
				message: i18n.t('EMPLOYEES__MESSAGE_ADD_BATCH'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			updateBulk: {
				title: i18n.t('EMPLOYEES__TITLE_UPDATE_BATCH'),
				message: i18n.t('EMPLOYEES__MESSAGE_UPDATE_BATCH'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			removeBulk: {
				title: i18n.t('EMPLOYEES__TITLE_REMOVE_BATCH'),
				message: i18n.t('EMPLOYEES__MESSAGE_REMOVE_BATCH'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
			removeDocumentFile: {
				title: i18n.t('EMPLOYEE__DOCUMENT_TITLE_REMOVE'),
				message: i18n.t('EMPLOYEE__DOCUEMNT_MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
			downloadDocumentFile: {
				title: i18n.t('EMPLOYEE__TITLE_DOWNLOAD'),
				message: i18n.t('EMPLOYEE__MESSAGE_DOWNLOAD'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
		},
		equipment: {
			add: {
				title: i18n.t('EQUIPMENT__TITLE_ADD'),
				message: i18n.t('EQUIPMENT__MESSAGE_ADD'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			update: {
				title: i18n.t('EQUIPMENT__TITLE_UPDATE'),
				message: i18n.t('EQUIPMENT__MESSAGE_UPDATE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			remove: {
				title: i18n.t('EQUIPMENT__TITLE_REMOVE'),
				message: i18n.t('EQUIPMENT__MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
			addBulk: {
				title: i18n.t('EQUIPMENTS__TITLE_ADD_BATCH'),
				message: i18n.t('EQUIPMENTS__MESSAGE_ADD_BATCH'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			updateBulk: {
				title: i18n.t('EQUIPMENTS__TITLE_UPDATE_BATCH'),
				message: i18n.t('EQUIPMENTS__MESSAGE_UPDATE_BATCH'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			removeBulk: {
				title: i18n.t('EQUIPMENTS__TITLE_REMOVE_BATCH'),
				message: i18n.t('EQUIPMENTS__MESSAGE_REMOVE_BATCH'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
			removeDocumentFile: {
				title: i18n.t('EQUIPMENT__DOCUMENT_TITLE_REMOVE'),
				message: i18n.t('EQUIPMENT__DOCUMENT_MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
			downloadDocumentFile: {
				title: i18n.t('EQUIPMENT__TITLE_DOWNLOAD'),
				message: i18n.t('EQUIPMENT__DOCUMENT_MESSAGE_DOWNLOAD'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
		},
		firmware: {
			add: {
				title: i18n.t('FIRMWARE__TITLE_ADD'),
				message: i18n.t('FIRMWARE__MESSAGE_ADD'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			update: {
				title: i18n.t('FIRMWARE__TITLE_UPDATE'),
				message: i18n.t('FIRMWARE__MESSAGE_UPDATE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			remove: {
				title: i18n.t('FIRMWARE__TITLE_REMOVE'),
				message: i18n.t('FIRMWARE__MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
		},
		insight: {
			add: {
				title: i18n.t('DATA_INSIGHT__TITLE_ADD'),
				message: i18n.t('DATA_INSIGHT__MESSAGE_ADD'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			update: {
				title: i18n.t('DATA_INSIGHT__TITLE_UPDATE'),
				message: i18n.t('DATA_INSIGHT__MESSAGE_UPDATE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			remove: {
				title: i18n.t('DATA_INSIGHT__TITLE_REMOVE'),
				message: i18n.t('DATA_INSIGHT__MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
		},
		integration: {
			add: {
				title: i18n.t('INTEGRATION__TITLE_ADD'),
				message: 'Deseja adicionar nova integração?',
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			update: {
				title: i18n.t('INTEGRATION__TITLE_UPDATE'),
				message: i18n.t('INTEGRATION__MESSAGE_UPDATE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			remove: {
				title: i18n.t('INTEGRATION__TITLE_REMOVE'),
				message: i18n.t('INTEGRATION__MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
		},
		logSchema: {
			add: {
				title: i18n.t('LOG_SCHEMA__TITLE_ADD'),
				message: i18n.t('LOG_SCHEMA__MESSAGE_ADD'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			update: {
				title: i18n.t('LOG_SCHEMA__TITLE_UPDATE'),
				message: i18n.t('LOG_SCHEMA__MESSAGE_UPDATE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			remove: {
				title: i18n.t('LOG_SCHEMA__TITLE_REMOVE'),
				message: i18n.t('LOG_SCHEMA__MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
		},
		logType: {
			add: {
				title: i18n.t('LOG_TYPE__TITLE_ADD'),
				message: i18n.t('LOG_TYPE__MESSAGE_ADD'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			update: {
				title: i18n.t('LOG_TYPE__TITLE_UPDATE'),
				message: i18n.t('LOG_TYPE__MESSAGE_UPDATE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			remove: {
				title: i18n.t('LOG_TYPE__TITLE_REMOVE'),
				message: i18n.t('LOG_TYPE__MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
		},
		permissionGroup: {
			add: {
				title: i18n.t('PERMISSION_GROUP_TITLE_ADD'),
				message: i18n.t('PERMISSION_GROUP_MESSAGE_ADD'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			update: {
				title: i18n.t('PERMISSION_GROUP_TITLE_UPDATE'),
				message: i18n.t('PERMISSION_GROUP_MESSAGE_UPDATE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			remove: {
				title: i18n.t('PERMISSION_GROUP_TITLE_REMOVE'),
				message: i18n.t('PERMISSION_GROUP_MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
		},
		place: {
			add: {
				title: i18n.t('PLACE__TITLE_ADD'),
				message: i18n.t('PLACE__MESSAGE_ADD'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			update: {
				title: i18n.t('PLACE__TITLE_UPDATE'),
				message: i18n.t('PLACE__MESSAGE_UPDATE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			remove: {
				title: i18n.t('PLACE__TITLE_REMOVE'),
				message: i18n.t('PLACE__MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
			removeDocumentFile: {
				title: i18n.t('PLACE__DOCUMENT_TITLE_REMOVE'),
				message: i18n.t('PLACE__MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
			downloadDocumentFile: {
				title: i18n.t('PLACE__TITLE_DOWNLOAD'),
				message: i18n.t('PLACE__DOCUMENT_MESSAGE_DOWNLOAD'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
		},
		product: {
			add: {
				title: i18n.t('PRODUCT__TITLE_ADD'),
				message: i18n.t('PRODUCT__MESSAGE_ADD'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			update: {
				title: i18n.t('PRODUCT__TITLE_UPDATE'),
				message: i18n.t('PRODUCT__MESSAGE_UPDATE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			remove: {
				title: i18n.t('PRODUCT__TITLE_REMOVE'),
				message: i18n.t('PRODUCT__MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
		},
		tag: {
			update: {
				title: 'Atualizar tag',
				message: 'Deseja atualizar a tag?',
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			remove: {
				title: i18n.t('TAG__TITLE_REMOVE'),
				message: i18n.t('TAG__MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
		},
		user: {
			add: {
				title: i18n.t('USER__TITLE_ADD'),
				message: i18n.t('USER__MESSAGE_ADD'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			update: {
				title: i18n.t('USER__TITLE_UPDATE'),
				message: i18n.t('USER__MESSAGE_UPDATE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__CONFIRM'),
				},
			},
			remove: {
				title: i18n.t('USER__TITLE_REMOVE'),
				message: i18n.t('USER__MESSAGE_REMOVE'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__ACTION__REMOVE'),
					confirmButtonColor: 'red',
				},
			},
			logout: {
				title: i18n.t('COMMON__APPLICATION_LOGOUT_TITLE'),
				message: i18n.t('COMMON__MESSAGE_APPLICATION_LOGOUT'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__APPLICATION_LOGOUT_TITLE'),
				},
			},
			language: {
				title: i18n.t('COMMON__APPLICATION_LOGOUT_ATTENTION'),
				message: i18n.t('USER__MESSAGE_UPDATE_USER'),
				options: {
					confirmButtonLabel: i18n.t('COMMON__APPLICATION_ACTION_LOGOUT_OK'),
				},
			},
		},
	},
	messages: {
		1000: {
			pt: 'Versão não encontrada',
			en: 'Version not found',
			'es-ES': 'Versión no encontrada',
		},
		1001: {
			pt: 'Access token não informado',
			en: 'Access token not informed',
			'es-ES': 'Access token no informado',
		},
		1003: {
			pt: 'Access token inválido',
			en: 'Invalid access token',
			'es-ES': 'Access token no válido',
		},
		1004: {
			pt: 'Access token expirado',
			en: 'Expired access token',
			'es-ES': 'Token de acceso caducado',
		},
		1005: {
			pt: 'Operation inválida',
			en: 'Inalid Operation',
			'es-ES': 'Operación no válida',
		},
		1006: {
			pt: 'Nome de usuário não informado',
			en: 'User name not informed',
			'es-ES': 'Nombre de usuario no facilitado',
		},
		1007: {
			pt: 'Senha não informada',
			en: 'Password not informed',
			'es-ES': 'Contraseña no informada',
		},
		1008: {
			pt: 'E-mail/senha inválido',
			en: 'Invalid email/password',
			'es-ES': 'Correo electrónico/contraseña no válidos',
		},
		1010: {
			pt: 'Token não informado',
			en: 'Token not informed',
			'es-ES': 'Token no informado',
		},
		1011: {
			pt: 'Origem não informada',
			en: 'Origin not informed',
			'es-ES': 'Origen no informado',
		},
		1012: {
			pt: 'Versão não encontrada',
			en: 'Version not found',
			'es-ES': 'Versión no encontrada',
		},
		1014: {
			pt: 'Não é possível criar o refresh token',
			en: 'Unable to create the refresh token',
			'es-ES': 'No se puede crear el refresh token',
		},
		1015: {
			pt: 'Erro inesperado',
			en: 'Unexpected error',
			'es-ES': 'Error inesperado',
		},
		1016: {
			pt: 'Usuário não informado',
			en: 'User not informed',
			'es-ES': 'Usuario no informado',
		},
		1017: {
			pt: 'ID não informado',
			en: 'ID not informed',
			'es-ES': 'ID no informado',
		},
		1018: {
			pt: 'Transação não encontrada',
			en: 'Transaction not found',
			'es-ES': 'Transacción no encontrada',
		},
		1019: {
			pt: 'Acess token de rede social não informado',
			en: 'Access to social network token not informed',
			'es-ES': 'Access token de red social no informado',
		},
		1020: {
			pt: 'Recurso não encontrado',
			en: 'Resource not found',
			'es-ES': 'Recurso no encontrado',
		},
		1021: {
			pt: 'E-mail não informado',
			en: 'Email not informed',
			'es-ES': 'Correo electrónico no facilitado',
		},
		1022: {
			pt: 'Endereço não informado',
			en: 'Address not informed',
			'es-ES': 'Dirección no indicada',
		},
		1023: {
			pt: 'Tipo insperado',
			en: 'Unexpected type',
			'es-ES': 'Tipo inesperado',
		},
		1024: {
			pt: 'Tipo inválido',
			en: 'Invalid type',
			'es-ES': 'Tipo no válido',
		},
		1025: {
			pt: 'Operação não informada',
			en: 'Operation not informed',
			'es-ES': 'Operación no comunicada',
		},
		1026: {
			pt: 'Usuário não encontrado',
			en: 'User not found',
			'es-ES': 'Usuario no encontrado',
		},
		1027: {
			pt: 'Data de criação inválida',
			en: 'Invalid creation date',
			'es-ES': 'Fecha de creación no válida',
		},
		1028: {
			pt: 'Data de atualização inválida',
			en: 'Invalid update date',
			'es-ES': 'Fecha de actualización no válida',
		},
		1029: {
			pt: 'Nenhum nome retornado - O escopo foi enviado?',
			en: 'No name returned - Has the scope been sent?',
			'es-ES': 'No se ha devuelto el bombre - ¿Se ha enviado el alcance?',
		},
		1030: {
			pt: 'Nenhum e-mail retornado - O escopo foi enviado?',
			en: 'No email returned - Has the scope been sent?',
			'es-ES':
				'No se ha devuelto el correo electrónico - ¿Se ha enviado el alcance?',
		},
		1031: {
			pt: 'Tipo não fornecido',
			en: 'Type not supplied',
			'es-ES': 'Tipo no facilitado',
		},
		1032: {
			pt: 'Nome inválido',
			en: 'Invalid name',
			'es-ES': 'Nombre no válido',
		},
		1033: {
			pt: 'Foto inválida',
			en: 'Invalid picture',
			'es-ES': 'Foto no válida',
		},
		1034: {
			pt: 'E-mail inválido',
			en: 'Invalid email',
			'es-ES': 'Correo electrónico no válido',
		},
		1035: {
			pt: 'CPF inválido',
			en: 'Invalid CPF',
			'es-ES': 'CPF no válido',
		},
		1036: {
			pt: 'Telefone inválido',
			en: 'Invalid phone',
			'es-ES': 'Número de teléfono no válido',
		},
		1037: {
			pt: 'Recurso inválido',
			en: 'Invalid resource',
			'es-ES': 'Recurso no válido',
		},
		1038: {
			pt: 'Tamanho de recurso excedido',
			en: 'Resource size exceeded',
			'es-ES': 'Tamaño del recurso superado',
		},
		1039: {
			pt: 'Usuário inválido',
			en: 'Invalid user',
			'es-ES': 'Usuario no válido',
		},
		1040: {
			pt: 'ID inválido',
			en: 'Invalid ID',
			'es-ES': 'Id no válido',
		},
		1041: {
			pt: 'Credencial não encontrada',
			en: 'Credential not found',
			'es-ES': 'Credencial no encontrada',
		},
		1042: {
			pt: 'Nome de usuário inválido',
			en: 'Invalid username',
			'es-ES': 'Nombre de usuario no válido',
		},
		1043: {
			pt: 'Senha inválida',
			en: 'Invalid password',
			'es-ES': 'Contraseña no válida',
		},
		1044: {
			pt: 'Nome de usuário duplicado',
			en: 'Duplicate username',
			'es-ES': 'Nombre de usuario duplicado',
		},
		1045: {
			pt: 'Fuso horário inválido',
			en: 'Invalid timezone',
			'es-ES': 'Zona horaria no válida',
		},
		1046: {
			pt: 'Perfil não informado',
			en: 'Profile not informed',
			'es-ES': 'Perfil no informado',
		},
		1047: {
			pt: 'Perfil inválido',
			en: 'Invalid profile',
			'es-ES': 'Perfil no válido',
		},
		1048: {
			pt: 'Perfil não encontrado',
			en: 'Profile not found',
			'es-ES': 'Perfil no encontrado',
		},
		1049: {
			pt: 'Erro de autenticação',
			en: 'Authentication error',
			'es-ES': 'Error de autenticación',
		},
		1050: {
			pt: 'Erro de autenticação - Token não encontrado',
			en: 'Authentication error - Token not found',
			'es-ES': 'Error de autenticación - Token no encontrado',
		},
		1051: {
			pt: 'Recurso não encontrado (path - service)',
			en: 'Resource not found (path - service)',
			'es-ES': 'Recurso no encontrado  (path-service)',
		},
		1052: {
			pt: 'Perfis inválidos',
			en: 'Invalid profiles',
			'es-ES': 'Perfiles no válidos',
		},
		1053: {
			pt: 'Perfis não fornecidos',
			en: 'Profiles not provided',
			'es-ES': 'Perfiles no facilitados',
		},
		1054: {
			pt: 'Usuário sem permissão para acessar o recurso',
			en: 'User without permission to access the resource',
			'es-ES': 'Usuario sin permiso para acceder al recurso',
		},
		1055: {
			pt: 'Credenciais não fornecidas',
			en: 'Credentials not provided',
			'es-ES': 'Credenciales no facilitadas',
		},
		1056: {
			pt: 'Credencial não informada',
			en: 'Credential not provided',
			'es-ES': 'Credencial no informada',
		},
		1057: {
			pt: 'Credencial inválida',
			en: 'Invalid credential',
			'es-ES': 'Credencial no válida',
		},
		1058: {
			pt: 'Token de sessão não encontrado ou o token não é mais válido',
			en: 'Session token not found or token not valid anymore',
			'es-ES': 'Token de sesión no encontrado o token no válido',
		},
		1059: {
			pt: 'Código de recuperação não informado',
			en: 'Recovery code not provided',
			'es-ES': 'Código de recuperación no informado',
		},
		1060: {
			pt: 'Código de recuperação inválido',
			en: 'Invalid recovery code',
			'es-ES': 'Código de recuperación no válido',
		},
		1061: {
			pt: 'Notificação não encontrada',
			en: 'Notification not found',
			'es-ES': 'Notificación no encontrada',
		},
		1062: {
			pt: 'Destinatário não informado',
			en: 'Receiver not informed',
			'es-ES': 'Destinatario no informado',
		},
		1063: {
			pt: 'Destinatário inválido',
			en: 'Invalid receiver',
			'es-ES': 'Destinatario no válido',
		},
		1064: {
			pt: 'Link inválido ou expirado.',
			en: 'Invalid ou expired link',
			'es-ES': 'Link no válido o caducado',
		},
		1065: {
			pt: 'CPF não informado',
			en: 'CPF not provided',
			'es-ES': 'CPF no informado',
		},
		1066: {
			pt: 'Nome não informado',
			en: 'Name not provided',
			'es-ES': 'Nombre no informado',
		},
		1067: {
			pt: 'Credentiais inválidas',
			en: 'Invalid credentials',
			'es-ES': 'Credenciales no válidas',
		},
		1068: {
			pt: 'Conta não informada',
			en: 'Account not provided',
			'es-ES': 'Cuenta no informada',
		},
		1069: {
			pt: 'Conta inválida',
			en: 'Invalid account',
			'es-ES': 'Cuenta no válida',
		},
		1070: {
			pt: 'Produto não informado',
			en: 'Product not provided',
			'es-ES': 'Producto no informado',
		},
		1071: {
			pt: 'Produto inválido',
			en: 'Invalid product',
			'es-ES': 'Producto no válido',
		},
		1072: {
			pt: 'Perfil não informado',
			en: 'Profile not provided',
			'es-ES': 'Perfíl no informado',
		},
		1073: {
			pt: 'Perfil inválido',
			en: 'Invalid profile',
			'es-ES': 'Perfíl no válido',
		},
		1074: {
			pt: 'Estágio não informado',
			en: 'Stage not provided',
			'es-ES': 'Etapa no informada',
		},
		1075: {
			pt: 'Estágio inválido',
			en: 'Invalid stage',
			'es-ES': 'Etapa no válida',
		},
		1076: {
			pt: 'Status não informado',
			en: 'Status not provided',
			'es-ES': 'Estado no informado',
		},
		1077: {
			pt: 'Status inválido',
			en: 'Invalid status',
			'es-ES': 'Estado no válido',
		},
		1078: {
			pt: 'Versão de hardware não informada',
			en: 'Hardware version not provided',
			'es-ES': 'Versión de hardware no informada',
		},
		1079: {
			pt: 'Versão de hardware inválida',
			en: 'Invalid hardware version',
			'es-ES': 'Versión de hardware no válida',
		},
		1080: {
			pt: 'Versão de firmware não informada',
			en: 'Firmware version not provided',
			'es-ES': 'Versión de firmware no informada',
		},
		1081: {
			pt: 'Versão de firmware inválida',
			en: 'Invalid firmware version',
			'es-ES': 'Versión de firmware no válida',
		},
		1082: {
			pt: 'Lote não informado',
			en: 'Lot not informed',
			'es-ES': 'Lote no informado',
		},
		1083: {
			pt: 'Lote inválido',
			en: 'Invalid lot',
			'es-ES': 'Lote no válido',
		},
		1084: {
			pt: 'Comentários inválidos',
			en: 'Invalid observations',
			'es-ES': 'Comentarios no válidos',
		},
		1085: {
			pt: 'Dispositivo não encontrado',
			en: 'Device not found',
			'es-ES': 'Dispositivo no encontrado',
		},
		1086: {
			pt: 'Conta não encontrada',
			en: 'Account not found',
			'es-ES': 'Cuenta no encontrada',
		},
		1087: {
			pt: 'Pedido inválido',
			en: 'Invalid request',
			'es-ES': 'Solicitud inválida',
		},
		1088: {
			pt: 'Matrícula não informada',
			en: 'Registration not provided',
			'es-ES': 'Inscripción no informada',
		},
		1089: {
			pt: 'Matrícula inválida',
			en: 'Invalid registration',
			'es-ES': 'Inscripción no válida',
		},
		1090: {
			pt: 'Departamento não informado',
			en: 'Department not provided',
			'es-ES': 'Departamento no informado',
		},
		1091: {
			pt: 'Departamento inválido',
			en: 'Invalid department',
			'es-ES': 'Departamento no válido',
		},
		1092: {
			pt: 'Unidade não informada',
			en: 'Unit not provided',
			'es-ES': 'Unidad no informada',
		},
		1093: {
			pt: 'Unidade inválida',
			en: 'Invalid unit',
			'es-ES': 'Unidad no válida',
		},
		1094: {
			pt: 'Aniversário não informado',
			en: 'Birthday date not provided',
			'es-ES': 'Cumpleaños no informado',
		},
		1095: {
			pt: 'Aniversário inválido',
			en: 'Invalid birthday date',
			'es-ES': 'Cumpleaños no válido',
		},
		1096: {
			pt: 'Colaborador não encontrado',
			en: 'Employee not found',
			'es-ES': 'Empleado no encontrado',
		},
		1097: {
			pt: 'Fabricante não informado',
			en: 'Manufacturer not informed',
			'es-ES': 'Fabricante no informado',
		},
		1098: {
			pt: 'Fabricante inválido',
			en: 'Invalid manufacturer',
			'es-ES': 'Fabricante no válido',
		},
		1099: {
			pt: 'Modelo não informado',
			en: 'Model not informed',
			'es-ES': 'Modelo no informado',
		},
		1100: {
			pt: 'Modelo inválido',
			en: 'Invalid model',
			'es-ES': 'Modelo no válido',
		},
		1101: {
			pt: 'Ano não informado',
			en: 'Year not informed',
			'es-ES': 'Año no informado',
		},
		1102: {
			pt: 'Ano inválido',
			en: 'Invalid year',
			'es-ES': 'Año no válido',
		},
		1103: {
			pt: 'Associações inválidas',
			en: 'Invalid association',
			'es-ES': 'Asociaciones no válidas',
		},
		1104: {
			pt: 'Ordem não informada',
			en: 'Order not informed',
			'es-ES': 'Orden no informada',
		},
		1105: {
			pt: 'Dispositivos não informados',
			en: 'Devices not informed',
			'es-ES': 'Dispositivos no informado',
		},
		1106: {
			pt: 'Dispositivos inválidos',
			en: 'Invalid devices',
			'es-ES': 'Dispositivos no válido',
		},
		1107: {
			pt: 'Dispositivo inválido',
			en: 'Invalid device',
			'es-ES': 'Dispositivo no válido',
		},
		1108: {
			pt: 'Equipmento não encontrado',
			en: 'Equipment not found',
			'es-ES': 'Equipamiento no encontrado',
		},
		1109: {
			pt: 'UID não informado',
			en: 'UID not informed',
			'es-ES': 'UID no informado',
		},
		1110: {
			pt: 'UID inválido',
			en: 'Invalid UID',
			'es-ES': 'UID no válido',
		},
		1111: {
			pt: 'Data não informada',
			en: 'Date not informed',
			'es-ES': 'Fecha no informada',
		},
		1112: {
			pt: 'Data inválida',
			en: 'Invalid date',
			'es-ES': 'Fecha no válida',
		},
		1113: {
			pt: 'Código não informado',
			en: 'Code not informed',
			'es-ES': 'Código no informado',
		},
		1114: {
			pt: 'Código inválido',
			en: 'Invalid code',
			'es-ES': 'Código no válido',
		},
		1115: {
			pt: 'Evento não encontrado',
			en: 'Event not found',
			'es-ES': 'Evento no encontrado',
		},
		1116: {
			pt: 'Dado não informado',
			en: 'Data not informed',
			'es-ES': 'Dato no informado',
		},
		1117: {
			pt: 'Dado inválido',
			en: 'Invalid data',
			'es-ES': 'Dato no válido',
		},
		1118: {
			pt: 'Operação inválida',
			en: 'Invalid operation',
			'es-ES': 'Operación no válida',
		},
		1119: {
			pt: 'Part number não informado',
			en: 'Part number not informed',
			'es-ES': 'Part number no encontrado',
		},
		1120: {
			pt: 'Part number inválido',
			en: 'Invalid part number',
			'es-ES': 'Part number no válido',
		},
		1121: {
			pt: 'Perfis não informados',
			en: 'Profiles not informed',
			'es-ES': 'Perfiles no informados',
		},
		1122: {
			pt: 'Perfis inválidos',
			en: 'Invalid profiles',
			'es-ES': 'Perfiles no válidos',
		},
		1123: {
			pt: 'Produto não encontrado',
			en: 'Product not found',
			'es-ES': 'Producto no encontrado',
		},
		1124: {
			pt: 'Frame não informado',
			en: 'Frame not informed',
			'es-ES': 'Frame no informado',
		},
		1125: {
			pt: 'Frame inválido',
			en: 'Invalid frame',
			'es-ES': 'Frame no válido',
		},
		1126: {
			pt: 'Matrícula não encontrada',
			en: 'Registration not found',
			'es-ES': 'Inscripción no encontrada',
		},
		1127: {
			pt: 'Nome da empresa não encontrado',
			en: 'Company name not found',
			'es-ES': 'Nombre de empresa no encontrado',
		},
		1128: {
			pt: 'Nome da empresa inválido',
			en: 'Invalid company name',
			'es-ES': 'Nombre de empresa no válido',
		},
		1129: {
			pt: 'Nome fantasia não encontrado',
			en: 'Trade name not found',
			'es-ES': 'Nombre de fantasía no encontrado',
		},
		1130: {
			pt: 'Nome fantasia inválido',
			en: 'Invalid trade name',
			'es-ES': 'Nombre de fantasía no válido',
		},
		1131: {
			pt: 'CNPJ inválido',
			en: 'Invalid CNPJ',
			'es-ES': 'CNPJ no válido',
		},
		1132: {
			pt: 'IE inválida',
			en: 'Invalid State Registration',
			'es-ES': 'Registro estatal no válido',
		},
		1133: {
			pt: 'IM inválida',
			en: 'Invalid municipal registration',
			'es-ES': 'Registro municipal inválido',
		},
		1134: {
			pt: 'Comentários inválidos',
			en: 'Invalid comments',
			'es-ES': 'Comentarios no válidos',
		},
		1135: {
			pt: 'Nome de contato inválido',
			en: 'Invalid contact name',
			'es-ES': 'Nombre de contacto no válido',
		},
		1136: {
			pt: 'Telefone de contato inválido',
			en: 'Invalid contact phone',
			'es-ES': 'Número de teléfono de contacto no válido',
		},
		1137: {
			pt: 'E-mail de contato inválido',
			en: 'Invalid contact email',
			'es-ES': 'Correo electrónico de contacto no válido',
		},
		1138: {
			pt: 'Logradouro inválido',
			en: 'Invalid address street',
			'es-ES': 'Calle no válida',
		},
		1139: {
			pt: 'Número inválido',
			en: 'Invalid address number',
			'es-ES': 'Número no válido',
		},
		1140: {
			pt: 'Complemento inválido',
			en: 'Invalid address complement',
			'es-ES': 'Complemento no válido',
		},
		1141: {
			pt: 'CEP inválido',
			en: 'Invalid Zip Code',
			'es-ES': 'Código Postal no válido',
		},
		1142: {
			pt: 'Bairro inválido',
			en: 'Invalid neighboorhood',
			'es-ES': 'Barrio no válido',
		},
		1143: {
			pt: 'Cidade inválida',
			en: 'Invalid city',
			'es-ES': 'Ciudad no válida',
		},
		1144: {
			pt: 'Estado inválido',
			en: 'Invalid state',
			'es-ES': 'Estado no válido',
		},
		1145: {
			pt: 'Data de início de contato inválida',
			en: 'Invalid contact start date',
			'es-ES': 'Fecha de inicio del contacto no válida',
		},
		1146: {
			pt: 'Data de fim de contato inválida',
			en: 'Invalid contact end date',
			'es-ES': 'Fecha de fin de contacto no válida',
		},
		1147: {
			pt: 'Número de contrato inválido',
			en: 'Invalid contract number',
			'es-ES': 'Número de contrato no válido',
		},
		1148: {
			pt: 'Cor primária inválida',
			en: 'Invalid primary color',
			'es-ES': 'Color primario no válido',
		},
		1149: {
			pt: 'Cor secundária inválida',
			en: 'Invalid secondary color',
			'es-ES': 'Color secundario no válido',
		},
		1150: {
			pt: 'Slogan inválido',
			en: 'Invalid slogan',
			'es-ES': 'Lema no válido',
		},
		1151: {
			pt: 'Link inválido',
			en: 'Invalid link',
			'es-ES': 'Link no válido',
		},
		1152: {
			pt: 'CNPJ não informado',
			en: 'CNPJ not informed',
			'es-ES': 'CNPJ no informado',
		},
		1153: {
			pt: 'Módulo não informado',
			en: 'Module not informed',
			'es-ES': 'Módulo no informado',
		},
		1154: {
			pt: 'Módulo inválido',
			en: 'Invalid module',
			'es-ES': 'Módulo no válido',
		},
		1155: {
			pt: 'Itens não informados',
			en: 'Items not informed',
			'es-ES': 'Artículos no indicados',
		},
		1156: {
			pt: 'Items inválidos',
			en: 'Invalid items',
			'es-ES': 'Artículos no válidos',
		},
		1157: {
			pt: 'Grupos não informados',
			en: 'Groups not informed',
			'es-ES': 'Grupos no indicados',
		},
		1158: {
			pt: 'Grupos inválidos',
			en: 'Invalid groups',
			'es-ES': 'Grupos no válidos',
		},
		1159: {
			pt: 'Grupo inválido',
			en: 'Invalid group',
			'es-ES': 'Grupo no válido',
		},
		1160: {
			pt: 'E-mail duplicado',
			en: 'Duplicate email',
			'es-ES': 'Correo electrónico duplicado',
		},
		1161: {
			pt: 'Chave duplicada',
			en: 'Duplicate key',
			'es-ES': 'Clave duplicada',
		},
		1162: {
			pt: 'URL duplicada',
			en: 'Duplicate URL',
			'es-ES': 'URL duplicada',
		},
		1163: {
			pt: 'Purchase order inválido',
			en: 'Invalid purchase order',
			'es-ES': 'Purchase order no válido',
		},
		1164: {
			pt: 'Responsável inválido',
			en: 'Invalid reponsible',
			'es-ES': 'Responsable no válido',
		},
		1165: {
			pt: 'Data início inválida',
			en: 'Invalid start date',
			'es-ES': 'Fecha de inicio no válida',
		},
		1166: {
			pt: 'Data fim inválida',
			en: 'Invalid end date',
			'es-ES': 'Fecha final no válida',
		},
		1167: {
			pt: 'Descrição inválida',
			en: 'Invalid description',
			'es-ES': 'Descripción no válida',
		},
		1168: {
			pt: 'Número de série inválido',
			en: 'Invalid serial number',
			'es-ES': 'Número de serie no válido',
		},
		1169: {
			pt: 'Número de série não informado',
			en: 'Serial number not informed',
			'es-ES': 'Número de serie no indicado',
		},
		1170: {
			pt: 'Integração não encontrada',
			en: 'Integration not found',
			'es-ES': 'Integración no encontrada',
		},
		1171: {
			pt: 'UID duplicado',
			en: 'Duplicate UID',
			'es-ES': 'UID duplicado',
		},
		1172: {
			pt: 'Matrícula duplicada',
			en: 'Duplicate registration',
			'es-ES': 'Inscripción duplicada',
		},
		1173: {
			pt: 'Code log duplicado',
			en: 'Duplicate codelog',
			'es-ES': 'Codelog duplicado',
		},
		1187: {
			pt: 'Ambiente não encontrado',
			en: 'Area not found',
			'es-ES': 'Zona no encontrada',
		},
		1188: {
			pt: 'Contrato não fornecido',
			en: 'Contract not provided',
			'es-ES': 'Contrato no proporcionado',
		},
		1189: {
			pt: 'Contrato Inválido',
			en: 'Invalid contract',
			'es-ES': 'Contrato no válido',
		},
		1190: {
			pt: 'Part number não fornecido',
			en: 'Part number not provided',
			'es-ES': 'Part number no potporcionado',
		},
		1191: {
			pt: 'Part number inválido',
			en: 'Invalid part number',
			'es-ES': 'Part number no válido',
		},
		1192: {
			pt: 'Action não fornecida',
			en: 'Action not provided',
			'es-ES': 'Action no proporcionada',
		},
		1193: {
			pt: 'Script não fornecido',
			en: 'Script not provided',
			'es-ES': 'Script no proporcionado',
		},
		1194: {
			pt: 'Script inválido',
			en: 'Invalid script',
			'es-ES': 'Script no válido',
		},
		1195: {
			pt: 'Linguagem  não fornecida',
			en: 'Language not provided',
			'es-ES': 'Idioma no facilitado',
		},
		1196: {
			pt: 'Linguagem inválida',
			en: 'Invalid language',
			'es-ES': 'Idioma no válido',
		},
		1197: {
			pt: 'Tipo de equipment não fornecido',
			en: 'Equipment type not provided',
			'es-ES': 'Tipo de equipamiento no proporcionado',
		},
		1198: {
			pt: 'Tipo de equipamento inválido',
			en: 'Invalid equipment type',
			'es-ES': 'Tipo de equipamiento no válido',
		},
		1199: {
			pt: 'Grupo de permissão não fornecido',
			en: 'Permission group not provided',
			'es-ES': 'Grupo de permisos no proporcionado',
		},
		1200: {
			pt: 'Grupo de permissão inválido',
			en: 'Invalid permission group',
			'es-ES': 'Grupo de permisos no válido',
		},
		1201: {
			pt: 'Número do ativo não fornecido',
			en: 'Active number not provided',
			'es-ES': 'Número de activo no facilitado',
		},
		1202: {
			pt: 'Número do ativo inválido',
			en: 'Invalid active number',
			'es-ES': 'Número de activo no válido',
		},
		1203: {
			pt: 'Módulo deve ser preenchido',
			en: 'Module must be filled in',
			'es-ES': 'Debe completarse el módulo',
		},
	},
};

export default { ...data };
